import { createRoute } from '@tanstack/react-router';
import { Route as shellRoute } from '../_shell';
import { AuditLog } from '@/features/settings/AuditLog';

export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/settings/audit',
  component: AuditLog,
});
